//#region Bank cell
export enum BankCellType {
  standard = 'standard',
  safekeeping = 'safekeeping',
}
//#region Bonds
export enum BondsEnum {
  corporate = 'corporate',
  municipal = 'municipal',
  sovereign = 'sovereign',
  investmentAndStructural = 'investmentAndStructural',
}
export enum RatingType {
  AAA = 'AAA',
  AA = 'AA',
  A = 'A',
  BBB = 'BBB',
  bb = 'bb',
  B = 'B',
  CCCp = 'ccc+',
  CCC = 'ccc',
  C_CCCm = 'c_to_ccc-',
  D = 'd',
}
export enum BondsKind {
  constantCoupon = 'constantCoupon',
  fixedRate = 'fixedRate',
  floaters = 'floaters',
  discount = 'discount',
  inflationLinked = 'inflationLinked',
  investment = 'investment',
  structured = 'structured',
  other = 'other',
}
//#region BrokerageAccount
export enum BrokerageAccountType {
  primary = 'primary',
  otc = 'otc',
  fixed = 'fixed',
}
export enum KeyAssetsType {
  structureProduct = 'structureProduct',
  substituteBonds = 'substituteBonds',
  eurobonds = 'eurobonds',
  corporateBonds = 'corporateBonds',
  federalLoanBonds = 'federalLoanBonds',
  bonds = 'bonds',
  commonShares = 'commonShares',
  preferredShares = 'preferredShares',
  investmentFunds = 'investmentFunds',
  options = 'options',
  futures = 'futures',
  currencyPairs = 'currencyPairs',
  other = 'other',
}
export enum BlockingReasonType {
  sanctions = 'sanctions',
  unsignedOrders = 'unsignedOrders',
  lackOfFundsForProvision = 'lackOfFundsForProvision',
  other = 'other',
}
//#region CentralizedWallet
export enum CurrenciesType {
  BTC = 'BTC',
  ETH = 'ETH',
  USDT = 'USDT',
  BNB = 'BNB',
  SOL = 'SOL',
  XRP = 'XRP',
  USDC = 'USDC',
  ADA = 'ADA',
  AVAX = 'AVAX',
  DOGE = 'DOGE',
  DOT = 'DOT',
  TRX = 'TRX',
  LINK = 'LINK',
  MATIC = 'MATIC',
  WBTC = 'WBTC',
  SHIB = 'SHIB',
  LTC = 'LTC',
  DAI = 'DAI',
  BCH = 'BCH',
  ICP = 'ICP',
  UNI = 'UNI',
  XLM = 'XLM',
  LEO = 'LEO',
  OKB = 'OKB',
  XMR = 'XMR',
  ETC = 'ETC',
  ATOM = 'ATOM',
  CRO = 'CRO',
  FIL = 'FIL',
  TUSD = 'TUSD',
  NEAR = 'NEAR',
  BTCB = 'BTCB',
  VET = 'VET',
  INJ = 'INJ',
  RUNE = 'RUNE',
  LDO = 'LDO',
  RNDR = 'RNDR',
  ALGO = 'ALGO',
  AAVE = 'AAVE',
  GRT = 'GRT',
  EGLD = 'EGLD',
  STX = 'STX',
  QNT = 'QNT',
  FTT = 'FTT',
  HNT = 'HNT',
  WEMIX = 'WEMIX',
  HBAR = 'HBAR',
  MKR = 'MKR',
  BUSD = 'BUSD',
  FTM = 'FTM',
  FLOW = 'FLOW',
  THETA = 'THETA',
  SAND = 'SAND',
  KCS = 'KCS',
  BSV = 'BSV',
  SNX = 'SNX',
  AXS = 'AXS',
  MANA = 'MANA',
  NEO = 'NEO',
  IOTA = 'IOTA',
  XTZ = 'XTZ',
  EOS = 'EOS',
  KAVA = 'KAVA',
  GALA = 'GALA',
  KLAY = 'KLAY',
  MINA = 'MINA',
  WOO = 'WOO',
  ar = 'ar',
  CFX = 'CFX',
  XEC = 'XEC',
  FXS = 'FXS',
  CHZ = 'CHZ',
  ROSE = 'ROSE',
  XDC = 'XDC',
  CAKE = 'CAKE',
  CRV = 'CRV',
  GNO = 'GNO',
  DYDX = 'DYDX',
  ELF = 'ELF',
  FET = 'FET',
  RPL = 'RPL',
  gt = 'gt',
  AKT = 'AKT',
  ZEC = 'ZEC',
  TWT = 'TWT',
  CSPR = 'CSPR',
  GAS = 'GAS',
  NEXO = 'NEXO',
  ht = 'ht',
  COMP = 'COMP',
  OneINCH = '1INCH',
  ZIL = 'ZIL',
  AGIX = 'AGIX',
  IOTX = 'IOTX',
  sc = 'sc',
  STORJ = 'STORJ',
  DASH = 'DASH',
  HOT = 'HOT',
  USDP = 'USDP',
  ILV = 'ILV',
}
// export enum CentralizedWalletType {
//   algorithmicCurrencies = 'algorithmicCurrencies',
//   stableCoins = 'stableCoins',
// }
//
// const CentralizedWalletTypesList = [
//   {
//     label: 'forms_assets:centralizedWallet.enums.type.algorithmicCurrencies',
//     key: CentralizedWalletType.algorithmicCurrencies,
//   },
//   {
//     label: 'forms_assets:centralizedWallet.enums.type.stableCoins',
//     key: CentralizedWalletType.stableCoins,
//   },
// ];
//#region CommercialRealEstate
export enum CommercialRealEstateType {
  retail = 'retail',
  office = 'office',
  warehouse = 'warehouse',
  production = 'production',
  recreation = 'recreation',
  agricultural = 'agricultural',
  condominium = 'condominium',
  other = 'other',
}
//#region Commodity
export enum BaseAssetType {
  aluminium = 'aluminium',
  chemicalProducts = 'Chemical products',
  diamonds = 'Diamonds',
  gold = 'Gold',
  grain = 'Grain',
  realEstate = 'realEstate',
  industrialMetals = 'Industrial metals',
  iridium = 'Iridium',
  lumber = 'Lumber',
  mineralProducts = 'Mineral products',
  nickel = 'nickel',
  nonFerrousMetals = 'Non-ferrous metals',
  palladium = 'Palladium',
  petroleum = 'Petroleum',
  petroleumProducts = 'Petroleum products',
  platinum = 'Platinum',
  rareEarthMetals = 'Rare earth metals',
  rhodium = 'Rhodium',
  ruthenium = 'Ruthenium',
  rawMaterial = 'Raw material',
  lead = 'Lead',
  zinc = 'Zinc',
  other = 'other',
}
export enum IssuerAndExchangePlatformType {
  informationSystemOperator = 'informationSystemOperator',
  bank = 'bank',
  legalEntity = 'legalEntity',
  other = 'other',
}

export enum PlaceOfRecord {
  cryptowallet = 'cryptowallet',
  financialInstitution = 'financialInstitution',
  document = 'document',
  other = 'other',
}
//#region Debit account
export enum DebitType {
  currentAccount = 'currentAccount',
  deposit = 'deposit',
}
// export const enum AccountTermType {
//   fixed = 'fixed',
//   nonFixed = 'nonFixed',
// }
//#region DecentralizedWallet
export enum CryptoWalletType {
  hot = 'hot',
  cold = 'cold',
}
// export enum WalletCurrencyType {
//   algorithmicCurrencies = 'algorithmicCurrencies',
//   stableCoins = 'stableCoins',
// }
//#region ExchangeOptions
export enum ExchangeOptionsType {
  call = 'call',
  put = 'put',
}
export enum OptionStyleType {
  european = 'european ', // TODO https://ownerone.atlassian.net/browse/WA-4686
  american = 'american ', // TODO https://ownerone.atlassian.net/browse/WA-4686
  asian = 'asian',
  quasiAmerican = 'quasiAmerican',
  other = 'other',
}
//#region Forwards
export enum ForwardsBasicType {
  commodity = 'commodity ', // TODO https://ownerone.atlassian.net/browse/WA-4686
  equity = 'equity',
  currency = 'currency',
  index = 'index',
  interestRate = 'interestRate',
  futuresContract = 'futuresContract',
  cryptocurrency = 'cryptocurrency',
  bonds = 'bonds',
  other = 'other',
}
export enum ForwardsType {
  deliveryBased = 'deliveryBased',
  cashSettled = 'cashSettled',
}
export enum ForwardOtherSideOfContract {
  legalEntity = 'legalEntity',
  person = 'person',
}
//#region Futures
export enum FuturesType {
  deliveryBased = 'deliveryBased',
  cashSettled = 'cashSettled',
}
export enum FuturesBasicType {
  commodity = 'commodity ', // TODO https://ownerone.atlassian.net/browse/WA-4686
  equity = 'equity',
  currency = 'currency',
  index = 'index',
  interestRate = 'interestRate',
  futuresContract = 'futuresContract',
  bonds = 'bonds',
  cryptocurrency = 'cryptocurrency',
  other = 'other',
}
export enum TradeDirectionType {
  long = 'long',
  short = 'short',
}
//#region Jewelry
export enum JewelryType {
  ring = 'ring',
  earrings = 'earrings',
  necklace = 'necklace',
  pendant = 'pendant',
  bracelet = 'bracelet',
  brooch = 'brooch',
  cufflinks = 'cufflinks',
  clasp = 'clasp',
  tiara = 'tiara',
  other = 'other',
}
export enum JewelryTypeName {
  brand = 'brand',
  relic = 'relic',
  customOrder = 'customOrder',
  vintage = 'vintage',
}
export enum MetalType {
  whiteGold = 'whiteGold',
  yellowGold = 'yellowGold',
  roseGold = 'roseGold',
  silver = 'silver',
  platinum = 'platinum',
  steel = 'steel',
  titanium = 'titanium',
  ceramic = 'ceramic',
  other = 'other',
}
export enum PreciousGemstonesTypeJewelry { // Old PreciousGemstonesType
  no = 'no',
  diamond = 'diamond',
  emerald = 'emerald',
  ruby = 'ruby',
  sapphire = 'sapphire',
  alexandrite = 'alexandrite',
  naturalPearl = 'naturalPearl',
  spinel = 'spinel',
  other = 'other',
}
export enum ItemConditionType {
  brandNew = 'brandNew',
  used = 'used',
}
//#region Land
export enum PermittedUseType {
  recreational = 'recreational',
  sanitary = 'sanitary',
}
//#region LegalEntity
export enum FormOfOrganizationType {
  public = 'public',
  individual = 'individual',
}
export enum LegalEntityUsageProfileType {
  personal = 'personal',
  commercial = 'commercial',
  investment = 'investment',
  strategic = 'strategic',
  other = 'other',
}
export enum TaxAgentType {
  company = 'company',
  person = 'person',
  other = 'other',
}
//#region MetalAccount
export enum MetalAccountType {
  gold = 'gold',
  silver = 'silver',
  platinum = 'platinum',
  palladium = 'palladium',
  other = 'other',
}
//#region MyFund
export enum MyFundType {
  revocable = 'revocable',
  irrevocable = 'irrevocable',
}
export enum TaskOfTheFundType {
  assetsProtection = 'assetProtection',
  assetsManagement = 'assetsManagement',
  assetTransfer = 'assetTransfer',
  confidentialityAssurance = 'confidentialityAssurance',
  financialOptimization = 'financialOptimization',
  other = 'other',
}
export enum ConfidentialityLevelType {
  openEnded = 'openEnded',
  closeEnded = 'closeEnded',
}
export enum ManagementStructureType {
  direct = 'direct',
  trustAgreement = 'trustAgreement',
  nominalOwnership = 'nominalOwnership',
}
//#region otcOptions
export enum OverTheCounterOptionsType {
  call = 'call',
  put = 'put',
}
export enum CounterpartyType {
  legalEntity = 'legalEntity',
  person = 'person',
}
export enum OtcOptionsAssetType {
  stocks = 'stocks',
  commodity = 'commodity ', // TODO https://ownerone.atlassian.net/browse/WA-4686
  currency = 'currency',
  index = 'index',
  interestRate = 'interestRate',
  futuresContract = 'futuresContract',
  bonds = 'bonds',
  cryptocurrency = 'cryptocurrency',
  other = 'other',
}
//#region PreciousGemstones
export enum TypeOfOrigin {
  natural = 'natural',
  synthetic = 'synthetic',
}
export enum AppraisalLaboratoryType {
  GIA = 'GIA',
  HRD = 'HRD',
  IGI = 'IGI',
  EGL = 'EGL',
  GAGLT = 'GAGLT',
  ISDI = 'ISDI',
  INDI = 'INDI',
  OTHER = 'other',
}
export enum ColorType {
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X',
  Y = 'Y',
  Z = 'Z',
  other = 'other',
}
export enum ClarityType {
  flawless = 'flawless',
  internallyFlawless = 'internallyFlawless',
  VVS1 = 'VVS1',
  VVS2 = 'VVS2',
  VS1 = 'VS1',
  VS2 = 'VS2',
  S1 = 'S1',
  S2 = 'S2',
  I1 = 'I1',
  I2 = 'I2',
  I3 = 'I3',
  other = 'other',
}
export enum CutAndPolishType {
  excellent = 'excellent',
  veryGood = 'veryGood',
  good = 'good',
  fair = 'fair',
  poor = 'poor',
  other = 'other',
}
export enum ShapeType {
  cushion = 'cushion',
  marquise = 'marquise',
  radiant = 'radiant',
  pear = 'pear',
  round = 'round',
  oval = 'oval',
  emerald = 'emerald',
  princess = 'princess',
  heart = 'heart',
  other = 'other',
}
export enum FluorescenceType {
  none = 'none',
  slight = 'slight',
  medium = 'medium',
  strong = 'strong',
  veryStrong = 'veryStrong',
  other = 'other',
}
//#region Public fund
export enum PublicFundType {
  VentureCapitalFund = 'VentureCapitalFund',
  HedgeFund = 'HedgeFund',
  PrivateFund = 'PrivateFund',
  RealEstateFund = 'RealEstateFund',
  IndexedFund = 'IndexedFund',
}
//#region ResidentialRealEstate
export enum ResidentialRealEstateType {
  flat = 'flat',
  studio = 'studio',
  apartment = 'apartment',
  condominium = 'condominium',
  house = 'house',
  cottage = 'cottage',
  duplex = 'duplex',
  bungalow = 'bungalow',
  chalet = 'chalet',
  townhouse = 'townhouse',
  ranch = 'ranch',
  penthouse = 'penthouse',
  villa = 'villa',
  mansion = 'mansion',
  castle = 'castle',
  estate = 'estate',
}
//#region Stocks
export enum SecuritiesAndStocksEnum {
  adr = 'adr',
  edr = 'edr',
  gdr = 'gdr',
  depositaryReceipts = 'depositaryReceipts',
  preferredStock = 'preferredStock',
  regular = 'regular',
}
export enum ManagerialRightsType {
  yes = 'yes',
  no = 'no',
  proportionally = 'proportionally',
  disproportionateUpward = 'disproportionateUpward',
  disproportionateDownward = 'disproportionateDownward',
}
export enum ClassOfSharesType {
  A = 'classA',
  B = 'classB',
  C = 'classC',
  OTHER = 'other',
}
export enum StrategyType {
  growthStock = 'growthStock',
  valueStock = 'valueStock',
  dividendStock = 'dividendStock',
  other = 'other',
}

// Bank-sell / deposit box
export enum BankCellAccessMethod {
  keys = 'keys',
  code = 'code',
  fingerprint = 'fingerprint',
  retina = 'retina',
  other = 'other',
}

//#region Jewelry / PreciousGemstones
export enum TypeOfHistoryOfOriginType {
  gift = 'gift',
  purchase = 'purchase',
  inheritance = 'inheritance',
  other = 'other',
}
export enum PreciousGemstonesType {
  diamond = 'diamond',
  ruby = 'ruby',
  emerald = 'emerald',
  sapphire = 'sapphire',
  other = 'other',
}
//#region MyFund / PublicFund
export enum FundUsageStrategyType {
  strategic = 'strategic',
  personal = 'personal',
  commercial = 'commercial',
  investment = 'investment',
  other = 'other',
}
export enum ManagementBodyType {
  manager = 'manager',
  boardOfDirectors = 'boardOfDirectors',
  managementCompany = 'managementCompany',
  other = 'other',
}

//#region Forwards / Futures
export enum SellerType {
  legalEntity = 'legalEntity',
  person = 'person',
}
export enum Seller {
  seller = 'seller',
  buyer = 'buyer',
}
// #region ExchangeOptions / OtcOptions
export enum StrategyBasicPositionType {
  buyingCall = 'buyingCall',
  sellingCall = 'sellingCall',
  buyingPut = 'buyingPut',
  sellingPut = 'sellingPut',
}
//#region Bond / Securities adn Stocks
export enum TradeType {
  etc = 'etc',
  otc = 'otc',
}
//#region ExchangeOptions / Forwards / Futures
// export enum BasicAssetType {
//   stocks = 'stocks',
//   commodity = 'commodity ',
//   equity = 'equity',
//   currency = 'currency',
//   index = 'index',
//   interestRate = 'interestRate',
//   futuresContract = 'futuresContract',
//   other = 'other',
// }
export enum BasicAssetType {
  equity = 'equity',
  stocks = 'stocks',
  commodity = 'commodity ', // TODO https://ownerone.atlassian.net/browse/WA-4686
  currency = 'currency',
  index = 'index',
  interestRate = 'interestRate',
  futuresContract = 'futuresContract',
  bonds = 'bonds',
  cryptocurrency = 'cryptocurrency',
  other = 'other',
}
